import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const DEFAULT_HEADLINE = "We're launching soon";
const DEFAULT_MESSAGE =
  'ACF Tourism is getting ready to help you book flights and hotels. Check back shortly or contact us for enquiries.';

const SiteStatusContext = createContext({
  loading: true,
  comingSoonEnabled: false,
  hotelSearchEnabled: false,
  headline: DEFAULT_HEADLINE,
  message: DEFAULT_MESSAGE,
  refetchSiteStatus: () => {},
});

export function SiteStatusProvider({ children }) {
  const [state, setState] = useState({
    loading: true,
    comingSoonEnabled: false,
    hotelSearchEnabled: false,
    headline: DEFAULT_HEADLINE,
    message: DEFAULT_MESSAGE,
  });
  const [refreshKey, setRefreshKey] = useState(0);

  const refetchSiteStatus = useCallback(() => {
    setRefreshKey((k) => k + 1);
  }, []);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/public/site-status`);
        if (!res.ok) throw new Error('site-status failed');
        const data = await res.json();
        if (cancelled) return;
        setState({
          loading: false,
          comingSoonEnabled: Boolean(data.coming_soon_enabled),
          hotelSearchEnabled: Boolean(data.hotel_search_enabled),
          headline: data.headline || DEFAULT_HEADLINE,
          message: data.message || DEFAULT_MESSAGE,
        });
      } catch {
        if (!cancelled) {
          setState((prev) => ({ ...prev, loading: false }));
        }
      }
    };
    if (refreshKey === 0) {
      setState((prev) => ({ ...prev, loading: true }));
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [refreshKey]);

  return (
    <SiteStatusContext.Provider value={{ ...state, refetchSiteStatus }}>
      {children}
    </SiteStatusContext.Provider>
  );
}

export function useSiteStatus() {
  return useContext(SiteStatusContext);
}
